module.exports = __webpack_public_path__ + "static/img/Group.b91af05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/dashboard/Group.png
// module id = ANVx
// module chunks = 134